﻿import AUtdanningValg from './Utilities/A-UtdanningsValg';
import BGradValg from './Utilities/B-GradsValg';
import { ValgState } from './Store/Valg/Types';
import { Resultat } from './Models/Resultat';
import VeilederOblDto from './Models/VeilederOblDto';

enum ResultatType {
    Unknown,
    ResA = 'ca',
    ResB = 'cb',
    ResC = 'cc',
    ResD = 'cd',
    ResE = 'ce',
    ResF = 'cf',
    ResG = 'cg',
    ResH = 'ch',
}

const basislanAndel = 'basislanAndel';
const basislanAndelUtenGrad = 'basislanAndelUtenGrad';
const basislanTekst = 'BasislanTekst';
const unntakTekst = 'UnntakTekst';
const narOverskrift = 'NarOverskrift';
const narTekst = 'NarTekst';

export const getResultat = (state: ValgState): Resultat => {
    const resultat = findResultat(state);
    const prefix = resultat.toString();

    return {
        hasUnntak: utenGrad(resultat),
        basislanAndelKey: utenGrad(resultat)
            ? (basislanAndelUtenGrad as keyof VeilederOblDto)
            : (basislanAndel as keyof VeilederOblDto),
        basislanTekstKey: prefix.concat(basislanTekst) as keyof VeilederOblDto,
        unntakTekstKey: utenGrad(resultat) ? (prefix.concat(unntakTekst) as keyof VeilederOblDto) : undefined,
        narOverskriftKey: prefix.concat(narOverskrift) as keyof VeilederOblDto,
        narTekstKey: prefix.concat(narTekst) as keyof VeilederOblDto,
    };
};

const utenGrad = (e: ResultatType): boolean => {
    return e === ResultatType.ResB || e === ResultatType.ResF;
};

const findResultat = (state: ValgState): ResultatType => {
    if (state.aUtdanning !== undefined) {
        if (state.aUtdanning.value === AUtdanningValg.a1_uniHoysk) {
            if (state.bGrad !== undefined) {
                if (state.bGrad.value === BGradValg.b1_bachelorMaster) {
                    return ResultatType.ResA;
                } else if (state.bGrad.value === BGradValg.b2_enkeltemnerSemester) {
                    return ResultatType.ResB;
                }
            }
        } else if (state.aUtdanning.value === AUtdanningValg.a2_folkehogskole) {
            return ResultatType.ResC;
        } else if (state.aUtdanning.value === AUtdanningValg.a3_annenHoyere) {
            return ResultatType.ResD;
        } else if (state.aUtdanning.value === AUtdanningValg.a4_uniHoyUtl) {
            if (state.bxGrad !== undefined) {
                if (state.bxGrad.value === BGradValg.b3_bachelorMasterx) {
                    return ResultatType.ResE;
                } else if (state.bxGrad.value === BGradValg.b4_enkeltemnerSemesterx) {
                    return ResultatType.ResF;
                } else if (state.bxGrad.value === BGradValg.b5_utveksling) {
                    return ResultatType.ResG;
                }
            }
        } else if (state.aUtdanning.value === AUtdanningValg.a5_annenHoyereUtl) {
            return ResultatType.ResH;
        }
    }
    return ResultatType.Unknown;
};
